export default async function isGuest({router }) {

    if (localStorage.getItem('token')) {
        router.push({ path: '/' });
        return false;
    }

    return true;
}
